<template>
  <div
    :class="['day', { 'is-drag-enter': isDragEnter, 'is-dragging': isDragging }]"
    :style="{
      '--start-day': name + '-start',
    }"
  >
    <slot></slot>
    <div
      :class="['day-shadow', { 'is-today': current, 'is-header': isHeader }]"
      @drop="onDrop"
      @dragenter="toggleDragEnter"
      @dragleave="toggleDragEnter"
      @dragover.prevent
      @dragenter.prevent
    />
  </div>
</template>

<script setup lang="ts">
import { inject, ref, ComputedRef } from 'vue'

const props = defineProps<{
  name: string
  current: boolean
  isHeader?: boolean
}>()
const emit = defineEmits<{ (name: 'drag-end'): void }>()
const isDragging = inject<{ isDragging: ComputedRef<boolean> }>('isDragging')
const isDragEnter = ref(false)

function onDrop() {
  emit('drag-end')
  isDragEnter.value = false
}

function toggleDragEnter() {
  isDragEnter.value = !isDragEnter.value
}
</script>

<style scoped>
.day {
  display: contents;
  position: relative;
}

.day-shadow {
  position: absolute;
  border-left: 1px solid var(--color-grey--lighter);
  grid-column: var(--start-day);
  width: 100%;
  height: 100%;
  z-index: var(--elevation-none);
  pointer-events: none;
}

.day.is-dragging .day-shadow {
  pointer-events: all;
}

.day-shadow.is-header {
  border-left-color: transparent;
}

.is-drag-enter .day-shadow {
  background-color: var(--color-grey);
  z-index: var(--elevation-base);
  opacity: 0.2;
}

.is-today {
  background-color: var(--color-blue--lighter);
  z-index: var(--elevation-none);
  opacity: 0.5;
}
</style>
